import React from 'react';

const Logo = ({ size = 32, className = '' }) => (
  <img
    src={process.env.PUBLIC_URL + '/researcher_logo.jpg'}
    alt="Logo"
    width={size}
    height={size}
    className={className}
    style={{ objectFit: 'contain', borderRadius: '4px' }}
  />
);

export default Logo;
